import {createFeatureSelector, createSelector} from "@ngrx/store";
import {relatedCasesFeatureKey, RelatedCasesState} from "../reducers/related-cases.reducers";

const relatedCasesFeatureState = createFeatureSelector<RelatedCasesState>(relatedCasesFeatureKey);

export const getRelatedCases = createSelector(
  relatedCasesFeatureState,
  state => state.relatedCases ?? null
);
